<template>
   <v-card class="mx-auto">
    <v-card-title class="font-weight-bold">
        All Donations
    </v-card-title>
    <v-divider />
    <div class="skeleton-list-item w-full" v-if="hourlyReportLoading">
        <v-skeleton-loader  :loading="true" type="image"></v-skeleton-loader>
    </div>
    <div class="ma-0 pa-9 text-center" v-if="!hourlyReportLoading && AllDonationSummary.length == 0">
        Donation Not Found!.
    </div>
    <v-simple-table class="pa-4" v-if="!hourlyReportLoading && AllDonationSummary">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center"></th>
            <th class="text-center"></th>
            <th class="text-center">This Hour</th>
            <th class="text-center">Past Hour</th>
            <th class="text-center">2 Hours Ago</th>
          </tr>
        </thead>
        <tbody class="simple-table-borders">
            <tr class="accent lighten-4">
                <td rowspan="2" class="text-center border-right border-left">Once</td>
                <td class="text-right border-right font-weight-bold">No. of donations added to the tally</td>
                <td class="text-center border-right">
                    {{AllDonationSummary.current && AllDonationSummary.current.once_count ? AllDonationSummary.current.once_count : 0}}
                </td>
                <td class="text-center border-right">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].once_count ? AllDonationSummary['1_hr_ago'].once_count : 0}}
                </td>
                <td class="text-center border-right">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].once_count ? AllDonationSummary['2_hr_ago'].once_count : 0}}
                </td>
            </tr>
            <tr class="accent lighten-4">
                <td class="text-right border-right font-weight-bold">$ value of donations added to the tally</td>
                <td class="text-center border-right">
                    {{AllDonationSummary.current && AllDonationSummary.current.once_amount ? AllDonationSummary.current.once_amount : 0}}
                </td>
                <td class="text-center border-right">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].once_amount ? AllDonationSummary['1_hr_ago'].once_amount : 0}}
                </td>
                <td class="text-center border-right">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].once_amount ? AllDonationSummary['2_hr_ago'].once_amount : 0}}
                </td>
            </tr>
            <tr style="height: 30px"></tr>
            <tr class="accent lighten-4">
                <td rowspan="2" class="text-center border-top border-right border-left">Recurring</td>
                <td class="text-right border-right border-top border-top font-weight-bold">No. of donations added to the tally</td>
                <td class="text-center border-right border-top">
                    {{AllDonationSummary.current && AllDonationSummary.current.rec_count ? AllDonationSummary.current.rec_count : 0}}
                </td>
                <td class="text-center border-right border-top">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].rec_count ? AllDonationSummary['1_hr_ago'].rec_count : 0}}
                </td>
                <td class="text-center border-top border-right">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].rec_count ? AllDonationSummary['2_hr_ago'].rec_count : 0}}
                </td>
            </tr>
            <tr class="accent lighten-4">
                <td class="text-right border-right font-weight-bold">$ value of donations received</td>
                <td class="text-center border-right">
                    {{AllDonationSummary.current && AllDonationSummary.current.rec_amount ? AllDonationSummary.current.rec_amount : 0}}
                </td>
                <td class="text-center border-right">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].rec_amount ? AllDonationSummary['1_hr_ago'].rec_amount : 0}}
                </td>
                <td class="text-center border-right">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].rec_amount ? AllDonationSummary['2_hr_ago'].rec_amount : 0}}
                </td>
            </tr>
            <tr style="height: 30px"></tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No of Incentive Donations</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.incentive_donation ? AllDonationSummary.current.incentive_donation : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].incentive_donation ? AllDonationSummary['1_hr_ago'].incentive_donation : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].incentive_donation ? AllDonationSummary['2_hr_ago'].incentive_donation : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No of new Donors</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.new_donors ? AllDonationSummary.current.new_donors : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].new_donors ? AllDonationSummary['1_hr_ago'].new_donors : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].new_donors ? AllDonationSummary['2_hr_ago'].new_donors : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No of Incentives</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.incentive_count ? AllDonationSummary.current.incentive_count : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].incentive_count ? AllDonationSummary['1_hr_ago'].incentive_count : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].incentive_count ? AllDonationSummary['2_hr_ago'].incentive_count : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">No. of donations added the inspiration fund</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.inspiration_count ? AllDonationSummary.current.inspiration_count : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].inspiration_count ? AllDonationSummary['1_hr_ago'].inspiration_count : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].inspiration_count ? AllDonationSummary['2_hr_ago'].inspiration_count : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">$ value of donations added to the inspiration fund</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.inspiration_amount ? AllDonationSummary.current.inspiration_amount : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].inspiration_amount ? AllDonationSummary['1_hr_ago'].inspiration_amount : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].inspiration_amount ? AllDonationSummary['2_hr_ago'].inspiration_amount : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">Total no. of donations</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.donation_count ? AllDonationSummary.current.donation_count : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].donation_count ? AllDonationSummary['1_hr_ago'].donation_count : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].donation_count ? AllDonationSummary['2_hr_ago'].donation_count : 0}}
                </td>
            </tr>
            <tr>
                <td class="border-none"></td>
                <td class="text-right border-right font-weight-bold border-none">$ Total value of donations</td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary.current && AllDonationSummary.current.donation_amount ? AllDonationSummary.current.donation_amount : 0}}
                </td>
                <td class="text-center border-right border-none">
                    {{AllDonationSummary['1_hr_ago'] && AllDonationSummary['1_hr_ago'].donation_amount ? AllDonationSummary['1_hr_ago'].donation_amount : 0}}
                </td>
                <td class="text-center border-none">
                    {{AllDonationSummary['2_hr_ago'] && AllDonationSummary['2_hr_ago'].donation_amount ? AllDonationSummary['2_hr_ago'].donation_amount : 0}}
                </td>
            </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['hourlyReportLoading', 'AllDonationSummary'])
  }
}
</script>
